var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("section", [
    _c("div", { staticClass: "m-subheader" }, [
      _c("div", { staticClass: "d-flex align-items-center" }, [
        _c("div", { staticClass: "mr-auto" }, [
          _c(
            "h3",
            { staticClass: "m-subheader__title m-subheader__title--separator" },
            [
              _vm._v(
                "\n          " +
                  _vm._s(_vm._f("titleize")("user_administration")) +
                  "\n        "
              )
            ]
          ),
          _vm._v(" "),
          _c("ul", {
            staticClass: "m-subheader__breadcrumbs m-nav m-nav--inline"
          })
        ])
      ])
    ]),
    _vm._v(" "),
    _c("div", { staticClass: "m-content", attrs: { id: "content" } }, [
      _c("div", { staticClass: "m-portlet m-portlet--tab" }, [
        _c("div", { staticClass: "m-portlet__head" }, [
          _c("div", { staticClass: "m-portlet__head-caption" }, [
            _c("div", { staticClass: "m-portlet__head-title" }, [
              _vm._m(0),
              _vm._v(" "),
              _c("h3", { staticClass: "m-portlet__head-text" }, [
                _vm._v(_vm._s(_vm._f("capitalize")("assign_permissions")))
              ])
            ])
          ])
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "m-portlet__body" }, [
          _c(
            "table",
            {
              staticClass: "table m-table m-table--head-bg-brand table-striped"
            },
            [
              _c("thead", [
                _c("tr", [
                  _c("th", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("capitalize")("code")) +
                        "  \n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("capitalize")("name")) +
                        "  \n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("capitalize")("description")) +
                        "\n              "
                    )
                  ]),
                  _vm._v(" "),
                  _c("th", [
                    _vm._v(
                      "\n                " +
                        _vm._s(_vm._f("capitalize")("state")) +
                        "\n              "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "tbody",
                _vm._l(_vm.groups, function(group) {
                  return _c("tr", { key: group.id }, [
                    _c("th", { attrs: { scope: "row" } }, [
                      _vm._v(
                        "\n                " +
                          _vm._s(group.code) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm._f("capitalize")(group.name)) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _vm._v(
                        "\n                " +
                          _vm._s(_vm._f("capitalize")(group.description)) +
                          "\n              "
                      )
                    ]),
                    _vm._v(" "),
                    _c("td", [
                      _c(
                        "label",
                        {
                          staticClass:
                            "m-checkbox m-checkbox--air m-checkbox--solid m-checkbox--state-brand"
                        },
                        [
                          _c("input", {
                            attrs: {
                              type: "checkbox",
                              name: "group-" + group.id,
                              id: "group-" + group.id
                            },
                            on: {
                              click: function($event) {
                                return _vm.updateGroup(group.id)
                              }
                            }
                          }),
                          _vm._v(" "),
                          _c("span")
                        ]
                      )
                    ])
                  ])
                }),
                0
              )
            ]
          )
        ])
      ])
    ])
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("span", { staticClass: "m-portlet__head-icon m--hide" }, [
      _c("i", {})
    ])
  }
]
render._withStripped = true
export { render, staticRenderFns }
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-13acdf4d", { render: render, staticRenderFns: staticRenderFns })
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-13acdf4d","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./app/javascript/src/components/admin/permissions/AssignGroup.vue
// module id = 726
// module chunks = 0 1 159